import { render, staticRenderFns } from "./updHsva.vue?vue&type=template&id=14524899"
import script from "./updHsva.vue?vue&type=script&lang=js"
export * from "./updHsva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports